import {
  ApiResponse,
  Curriculum,
  DuplicateCurriculumPayload,
  DuplicateCurriculumPayloadSchema,
  DuplicateCurriculumResponse,
} from "@twinkltech/curriculum-architect-domain-hooks";
import { useTwinklAnalytics } from "@twinkltech/web-analytics-ts";
import { useTranslation } from "react-i18next";

import { GenericCurriculumModal } from "@/components/GenericCurriculumModal/GenericCurriculumModal";

import { DUPLICATE_CURRICULUM_MODAL_NS } from "../DuplicateCurriculumModal.i18n";

export const IndividualDuplicateCurriculumModal = ({
  curriculum,
  onDuplicate,
  open,
  setOpen,
  ...props
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
  onDuplicate: (params: {
    payload: DuplicateCurriculumPayload;
  }) => ApiResponse<DuplicateCurriculumResponse>;
  curriculum?: Curriculum | null;
  loading?: boolean;
  error: Error | null;
}) => {
  const { t } = useTranslation(DUPLICATE_CURRICULUM_MODAL_NS);

  const { click } = useTwinklAnalytics();

  const onHandleDuplicate = async (data: Partial<Curriculum>) => {
    if (!curriculum) {
      return new Error("Curriculum is required for editing.");
    }
    const result = DuplicateCurriculumPayloadSchema.safeParse({
      ...data,
      curriculumIdToDuplicate: curriculum.id,
    });

    if (result.success) {
      click("click_duplicate_modal_cta", {
        clickCopy: "Save Duplicated Curriculum",
        clickLocation: "Duplicate Curriculum Modal",
      });

      return await onDuplicate({
        payload: result.data,
      });
    }

    console.error("Form data validation failed:", result.error);
    return result.error;
  };

  const onClickClose = () => {
    click("click_duplicate_modal_close", {
      clickCopy: "Close Duplicate Curriculum Modal",
      clickLocation: "Duplicate Curriculum Modal",
    });
  };

  return (
    <GenericCurriculumModal
      open={open}
      setOpen={setOpen}
      onClickClose={onClickClose}
      onSubmit={onHandleDuplicate}
      {...props}
      curriculum={
        curriculum
          ? {
              ...curriculum,
              displayLabel: `COPY OF ${curriculum.displayLabel}`,
            }
          : null
      }
      saveActionLabel={t("actions.save")}
      title={t("title")}
    />
  );
};
